import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { equals } from 'ramda';
import PropTypes from 'prop-types';
// we don't want the wrapped component - we
// are providing all props.
import { UncomposedSinglePickerField } from './singlePickerField';
import entityComposition from '../../common/classes/entityComposition';
import { getValueAtRemotePath } from '../utils';
import { contentSelector, enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
import logValueOnChange from '../commonActions/logValueOnChange';
const UserSinglePickerField = _ref => {
  let path = _ref.path,
    content = _ref.content,
    onChange = _ref.onChange,
    enabled = _ref.enabled,
    parentContentPath = _ref.parentContentPath,
    _ref$user = _ref.user,
    user_id = _ref$user.user_id,
    firstName = _ref$user.firstName,
    lastName = _ref$user.lastName,
    _ref$setCurrentUserIf = _ref.setCurrentUserIfNullOnUpdateToContentPath,
    setCurrentUserIfNullOnUpdateToContentPath = _ref$setCurrentUserIf === void 0 ? null : _ref$setCurrentUserIf,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? () => {} : _ref$onFocus,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label;
  const currentUser = {
    /* eslint-disable-next-line camelcase */
    id: user_id,
    title: "".concat(firstName, " ").concat(lastName)
  };
  let currentValueInContent = value;
  if (setCurrentUserIfNullOnUpdateToContentPath) {
    currentValueInContent = getValueAtRemotePath(path, setCurrentUserIfNullOnUpdateToContentPath, content);
  }
  const _useState = useState(currentValueInContent),
    _useState2 = _slicedToArray(_useState, 2),
    contentValueDuringLastRender = _useState2[0],
    setCurrentContentValue = _useState2[1];
  if (!equals(contentValueDuringLastRender, currentValueInContent) && currentValueInContent) {
    setCurrentContentValue(currentValueInContent);
    if (!value) {
      onChange({
        path,
        value: currentUser
        // prev values are null
      });
    }
  }

  // If the selected user is an other selection then the id
  // will come in as identifier, not id so we need to do some
  // massaging.
  const trueValue = value ? {
    title: value.title,
    id: value.id || value.identifier
  } : null;
  const handleChange = useCallback(_ref2 => {
    let fieldPath = _ref2.path,
      data = _ref2.value;
    if (!data) {
      return onChange({
        path: fieldPath,
        value: null
      });
    }
    if (data.id) {
      return onChange({
        path: fieldPath,
        value: data,
        displayValue: data.title
      });
    }
    const newValue = {
      identifier: data.identifier,
      title: data.title,
      id: null
    };

    // ensure the `id` value is cleared when handling 'other' data
    return onChange({
      path: fieldPath,
      value: newValue,
      displayValue: newValue.title
    });
  }, [onChange]);
  return /*#__PURE__*/React.createElement(UncomposedSinglePickerField, {
    value: trueValue,
    valueKey: "id",
    label: label,
    otherKey: "identifier",
    allowsOther: true,
    options: [currentUser],
    onChange: handleChange,
    className: className,
    enabled: enabled,
    path: path,
    onFocus: onFocus,
    parentContentPath: parentContentPath
  });
};
UserSinglePickerField.propTypes = {
  setCurrentUserIfNullOnUpdateToContentPath: PropTypes.string,
  value: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    identifier: PropTypes.string
  }),
  path: PropTypes.string.isRequired,
  label: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  parentContentPath: PropTypes.string.isRequired,
  content: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  user: PropTypes.shape({
    user_id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};
export { UserSinglePickerField as UncomposedUserSinglePickerField };
export default entityComposition(UserSinglePickerField, [], {
  user: state => state.login.user,
  value: valueSelector,
  enabled: enabledSelector,
  path: newPathSelector,
  onChange: logValueOnChange,
  content: contentSelector,
  label: labelSelector
});